import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex items-center mb-2" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = {
  key: 0,
  class: "mb-8 text-muted"
}
const _hoisted_5 = {
  key: 1,
  class: "banner banner-danger"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " error_outline ", -1)
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = {
  key: 2,
  class: "flex flex-col items-center opacity-70 card card-filled"
}
const _hoisted_10 = { class: "text-muted select-none" }
const _hoisted_11 = { class: "flex items-center mb-4 -mt-2" }
const _hoisted_12 = { class: "flex items-center mt-auto" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base material-icons-outlined" }, " add ", -1)
const _hoisted_14 = { class: "w-max" }
const _hoisted_15 = { class: "flex flex-col w-full space-y-2 md:space-y-0 md:items-center md:flex-row" }
const _hoisted_16 = { class: "flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SegmentedControls = _resolveComponent("SegmentedControls")!
  const _component_ArticleHandle = _resolveComponent("ArticleHandle")!
  const _component_EventTemplateRuleEditor = _resolveComponent("EventTemplateRuleEditor")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("event_template_editor.editor_title")), 1),
      (_ctx.modelValue.rules.length > 0)
        ? (_openBlock(), _createBlock(_component_SegmentedControls, {
            key: 0,
            small: true,
            class: "hidden ml-auto md:block",
            options: _ctx.viewModesAsOptions,
            modelValue: _ctx.viewMode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.viewMode) = $event))
          }, null, 8, ["options", "modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.showEditWarning)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t("event_template_editor.introduction_text")) + " ", 1),
            _createVNode(_component_ArticleHandle, { articleId: 'whats_exam_template' }),
            _createTextVNode(". ")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", null, [
              _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.$t("misc.warning")), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("event_editor.edit_template_in_progress_warning")), 1)
            ])
          ])),
      _createVNode(_component_draggable, {
        animation: "100",
        class: _normalizeClass({
					'grid grid-cols-2 2xl:grid-cols-3 gap-4 mb-10': _ctx.viewMode === 'grid',
				}),
        "ghost-class": "drag-ghost",
        "drag-class": "dragging-element",
        handle: ".drag-handle",
        "item-key": "id",
        modelValue: _ctx.modelValue.rules,
        onEnd: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRuleDragEnd($event)))
      }, {
        item: _withCtx(({ element, index }) => [
          _createVNode(_component_EventTemplateRuleEditor, {
            class: _normalizeClass([_ctx.viewMode === 'list' && index % 2 ? 'card-filled' : 'bg-white']),
            randomOrder: _ctx.randomRuleOrder,
            globallySelectedExercises: _ctx.selectedExercises,
            modelValue: element,
            lockRuleType: element.amount > 1,
            ordering: _ctx.getActualSlotOrdering(index),
            reduced: _ctx.viewMode === 'grid' || _ctx.viewMode === 'compact_list',
            onUpdateRule: ($event: any) => {
							_ctx.onRuleUpdate(element, $event.field, $event.value);
							_ctx.$emit('templateChanged');
						},
            onAddClause: ($event: any) => {
							_ctx.onRuleAddClause(element);
							_ctx.$emit('templateChanged');
						},
            onUpdateClause: ($event: any) => {
							_ctx.onRuleUpdateClause(element, $event);
							_ctx.$emit('templateChanged');
						},
            onDeleteClause: ($event: any) => {
							_ctx.onRuleDeleteClause(element, $event);
							_ctx.$emit('templateChanged');
						},
            onDeleteRule: ($event: any) => {
							_ctx.onRuleDelete(element);
							_ctx.$emit('templateChanged');
						}
          }, null, 8, ["class", "randomOrder", "globallySelectedExercises", "modelValue", "lockRuleType", "ordering", "reduced", "onUpdateRule", "onAddClause", "onUpdateClause", "onDeleteClause", "onDeleteRule"])
        ]),
        _: 1
      }, 8, ["class", "modelValue"]),
      ((_ctx.modelValue.rules?.length ?? 0) === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("event_template_editor.no_rules")), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _renderSlot(_ctx.$slots, "afterRules")
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_Btn, {
        class: "w-full md:w-max",
        onClick: _cache[2] || (_cache[2] = ($event: any) => {
					_ctx.onAddRule();
					_ctx.$emit('templateChanged');
				}),
        loading: _ctx.localLoading
      }, {
        default: _withCtx(() => [
          _hoisted_13,
          _createTextVNode(_toDisplayString(_ctx.$t("event_template_editor.add_rule")), 1)
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_DropdownMenu, {
        expanded: _ctx.addMultipleRulesExpanded,
        onToggleExpanded: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addMultipleRulesExpanded = !_ctx.addMultipleRulesExpanded)),
        class: "ml-0.5",
        placement: _ctx.mediaQueryMdMatches ? 'left' : 'right',
        tooltip: _ctx.$t('event_template_editor.add_more_rules')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("misc.add")), 1),
                _createVNode(_component_NumberInput, {
                  modelValue: _ctx.addRuleAmount,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addRuleAmount) = $event)),
                  class: "w-16 mx-2",
                  min: 2
                }, null, 8, ["modelValue"]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("misc.slots")), 1)
              ]),
              _createVNode(_component_Btn, {
                size: 'sm',
                class: "md:ml-12",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onAddRule(_ctx.addRuleAmount)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("misc.add")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["expanded", "placement", "tooltip"])
    ])
  ]))
}